import React from "react";
import T from "prop-types";
import { Field, ErrorMessage } from "formik";

import ShowIf from "../ShowIf";

import styles from "./Input.module.scss";

const Input = ({
    children,
    errors,
    disabled,
    inputClassName,
    label,
    name,
    onBlur,
    onDelete,
    placeholder,
    showDeleteButton,
    smallerMargin,
    touched,
    type
}) => {
    const fieldProps = {};

    if (onBlur) {
        fieldProps.onBlur = onBlur;
    }

    return (
        <div
            className={`field ${
                smallerMargin ? styles.fieldSmallerMargin : ""
            }`}
        >
            <label className="label">{label}</label>
            <div className="control has-icons-right">
                <Field
                    className={`input is-rounded ${
                        errors[name] && touched[name] ? "is-danger" : ""
                    } ${inputClassName || ""}`}
                    name={name}
                    placeholder={placeholder}
                    type={type || "text"}
                    disabled={disabled}
                    {...fieldProps}
                />
                {children}
                <ShowIf condition={showDeleteButton}>
                    <span
                        onClick={onDelete}
                        className={`icon is-right ${styles.deleteButton}`}
                    >
                        <i className="fas fa-times" />
                    </span>
                </ShowIf>
            </div>
            <ErrorMessage
                name={name}
                component="p"
                className="help is-danger is-size-6"
            />
        </div>
    );
};

Input.propTypes = {
    children: T.node,
    errors: T.object.isRequired,
    inputClassName: T.string,
    label: T.string,
    name: T.string.isRequired,
    onBlur: T.func,
    onDelete: T.func,
    placeholder: T.string,
    showDeleteButton: T.bool,
    smallerMargin: T.bool,
    touched: T.object.isRequired,
    type: T.string
};

export default Input;
